<div class="content-map">
<aside class="sidebar">
    <ng-container *transloco="let t">
        <div class="sidebar-header">
            <h2>{{ t('map.title') }}</h2>
            <p>{{ t('map.subtitle') }}<span *ngIf="totalLocations > 0"> ({{totalLocations}})</span></p>
        </div>
    </ng-container>
    <ng-container *ngIf="loadCompleted > 0">
        <ul class="location-list">
            <li *ngFor="let place of locations" class="location-item" (click)="zoomToLocation(place)" style="cursor: pointer;">
                <strong>{{ place.identifier }}</strong>
            </li>
        </ul>
    </ng-container>
</aside>    

<div class="main-layout">
    <div class="map-container">
        <div id="map" class="map-section-wrapper mapboxgl-map" _ngcontent-ng-c3889706223=""></div>
    </div>
</div>
</div>